import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CURRENCY_CONVERSION_OPTIONS } from '../../pages/guest/crossBorder';
import { localsMessages } from '../../utility/getTemplateData';
import { Tile } from '@paypalcorp/pp-react-tile';
import { Sheet } from '@paypalcorp/pp-react-sheet';
import { BodyText, CaptionText, HeadingText } from '@paypalcorp/pp-react-text';
import { Spot } from '@paypalcorp/pp-react-spot';
import { V2CheckmarkBackgroundIcon } from '@paypalcorp/pp-react-icons';
import { Button } from '@paypalcorp/pp-react-buttons';
import { checkKeyPressed } from '../../utility/accessibilityUtils';
const messages = localsMessages('guest/crossBorder');

const CurrencyConversionOption = (props) => {
  return (
    <Tile
      className={`${props.className} ${
        props.isSelected ? 'show-highlight' : 'border-default'
      }`}
      role="checkbox"
      aria-checked={props.isSelected}
      tabIndex="0"
      onClick={props.handleOptionSelection}
      onKeyDown={(e) =>
        checkKeyPressed(e, () => {
          props.handleOptionSelection();
        })
      }
    >
      <Tile.Content>
        <div className="conversion-tile">
          <Spot aria-hidden="true" name={props.spotImage} size="lg" />
          <div className="content">
            <BodyText className="title" strong>
              {props.title}
            </BodyText>
            {props.rate && <CaptionText strong>{props.rate}</CaptionText>}
            <CaptionText as="span">{props.description}</CaptionText>
          </div>
          <V2CheckmarkBackgroundIcon
            className={`icon-check ${!props.isSelected && 'hide-icon'}`}
            size="sm"
          />
        </div>
      </Tile.Content>
    </Tile>
  );
};

CurrencyConversionOption.propTypes = {
  isSelected: PropTypes.bool,
  title: PropTypes.string,
  rate: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
  handleOptionSelection: PropTypes.func,
  spotImage: PropTypes.string,
};

const CurrencyConversionModal = (props) => {
  const { label } = messages;
  const { selectedOption, exchangeRate } = props;
  const [isPayPalSelected, setPaypalSelected] = useState(
    selectedOption === CURRENCY_CONVERSION_OPTIONS.PAYPAL
  );

  const handleClose = () => {
    props.hideModal();
  };

  const handleNextButton = () => {
    props.handleOptionSelection(
      isPayPalSelected
        ? CURRENCY_CONVERSION_OPTIONS.PAYPAL
        : CURRENCY_CONVERSION_OPTIONS.ISSUER
    );
  };

  return (
    <Sheet
      className="currency-conversion-modal"
      title=""
      hideTitle={true}
      isOpen={props.isOpen}
      onClose={handleClose}
    >
      <HeadingText size="lg" className="text-center title">
        {label.modalTitle}
      </HeadingText>
      <BodyText className="text-center subTitle">
        {label.modalSubTitle}
      </BodyText>

      <CurrencyConversionOption
        isSelected={isPayPalSelected}
        title={label.withPaypal.title}
        rate={label.withPayPal.rate.replace(/{amount}/i, exchangeRate)}
        description={label.withPayPal.message}
        handleOptionSelection={() => setPaypalSelected(true)}
        className="option-paypal"
        spotImage="paypal-app"
      />
      <CurrencyConversionOption
        isSelected={!isPayPalSelected}
        title={label.withCard.title}
        description={label.withCard.message}
        handleOptionSelection={() => setPaypalSelected(false)}
        className="option-card"
        spotImage="credit-cards"
      />
      <div className="text-center">
        <Button className="btn-sheet-wide" onClick={handleNextButton}>
          {label.modalButton}
        </Button>
      </div>
    </Sheet>
  );
};

CurrencyConversionModal.propTypes = {
  handleOptionSelection: PropTypes.func.isRequired,
  hideModal: PropTypes.func,
  selectedOption: PropTypes.string,
  exchangeRate: PropTypes.string,
  isOpen: PropTypes.bool,
};

export default CurrencyConversionModal;
